import { useEffect, useState } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import { LanguageSelect } from '../LanguageSelect/LanguageSelect';
import type { LanguageOption } from '../LanguageSelect/types';

import { LANGUAGES_OPTIONS } from './constants';

type Props = {
  showTitlePrefixIcon?: boolean;
};
export const ChangeLanguage: React.FC<Props> = observer(function ChangeLanguage({ showTitlePrefixIcon }) {
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption>(LANGUAGES_OPTIONS[0]);

  const { userStore, authStore, gameStore, cmsStore } = useStores();
  const { language } = userStore.profile || {};

  const onChange = (lang: LanguageOption) => {
    setSelectedLanguage(lang);
    void authStore.updateUserProfile({ language: lang.id });
    userStore.updateProfile({ language: lang.id });
    gameStore.sendSlotsGameUiMessage({ type: 'setLanguage', payload: { language: lang.id } });
    void cmsStore.fetchLinks(lang.id);
    void cmsStore.fetchFooter(lang.id);
  };

  useEffect(() => {
    if (language) {
      setSelectedLanguage(
        LANGUAGES_OPTIONS.find((value) => value.id === language.toUpperCase()) || LANGUAGES_OPTIONS[0],
      );
    }
  }, [language]);

  return (
    <LanguageSelect
      name="language"
      options={LANGUAGES_OPTIONS}
      showSingleValuePrefixIcon={showTitlePrefixIcon}
      value={selectedLanguage}
      onChange={(newValue) => newValue && onChange(newValue)}
    />
  );
});
